import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [userId, setUserId] = useState(null);
  const [user, setUser] = useState(null);

  // Check localStorage for existing token and userId on mount
  useEffect(() => {
    const checkAuth = () => {
      const savedToken = localStorage.getItem("token");
      const savedUserId = localStorage.getItem("userId");
      const savedUser = localStorage.getItem("user");
      if (savedToken && savedUserId && savedUser) {
        setToken(savedToken);
        setUserId(savedUserId);
        setUser(JSON.parse(savedUser));
        setIsAuthenticated(true);
      }
    };
    checkAuth();
  }, []);

  const login = async (email, password) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;

      const response = await axios.post(`${apiUrl}/api/v1/login`, {
        email,
        password,
      });
      const { token, user } = response.data;

      // Validate that the user is a veterinary user.
      if (!user.veterinary) {
        return {
          success: false,
          user,
          message: "This login is restricted to veterinary users only.",
        };
      }

      // The API does not block login for unconfirmed accounts, so enforce
      // email confirmation on the client using the confirmed? flag it returns.
      if (!user["confirmed?"]) {
        return {
          success: false,
          unconfirmed: true,
          user,
          message:
            "Please confirm your email before logging in. Check your inbox for the confirmation link.",
        };
      }

      // Save token, userId, and user object to localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("userId", user.id.toString());
      localStorage.setItem("user", JSON.stringify(user));

      setToken(token);
      setUserId(user.id);
      setUser(user);
      setIsAuthenticated(true);

      return { success: true, user };
    } catch (error) {
      console.error("Login failed", error);
      return { success: false, message: "The credentials are incorrect." };
    }
  };

  const logout = async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    setToken(null);
    setUserId(null);
    setUser(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, login, logout, token, userId, user }}
    >
      {children}
    </AuthContext.Provider>
  );
};
